import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { useState } from 'react';

interface passwordProps {
    value: string;
    label: string;
    setValueHandler: (
        e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => void;
}

export const PasswordTextField: React.FC<passwordProps> = ({
    value,
    setValueHandler,
    label,
}) => {
    const [visible, setVisible] = useState(false);

    return (
        <TextField
            color="secondary"
            label={label}
            type={visible ? 'text' : 'password'}
            variant="standard"
            value={value}
            onChange={setValueHandler}
            sx={{ width: { xs: '90%', md: '50%', lg: '30%' } }}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            onClick={() =>
                                setVisible((prevState) => !prevState)
                            }
                        >
                            {visible && <VisibilityOffIcon />}
                            {!visible && <VisibilityIcon />}
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    );
};
